import { render } from "./loginByTelAndPassword _head.vue?vue&type=template&id=169a769c&scoped=true"
import script from "./loginByTelAndPassword _head.vue?vue&type=script&lang=js"
export * from "./loginByTelAndPassword _head.vue?vue&type=script&lang=js"

import "./loginByTelAndPassword _head.vue?vue&type=style&index=0&id=169a769c&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-169a769c"

export default script